export default "__VITE_ASSET__ojdSDo5x__"